import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonComponent } from './button.component';
import { RouterModule } from '@angular/router';
import { RedirectService } from 'src/app/shared/services/redirect/redirect.service';
import { RedirectModule } from 'src/app/shared/services/redirect/redirect.module';

@NgModule({
  declarations: [ButtonComponent],
  imports: [CommonModule, RouterModule, RedirectModule],
  exports: [ButtonComponent],
})
export class ButtonModule {}
